<template>
  <div style="width: 100%; height: 100%" v-resize:debounce="recalcWidthHeight" ref="refContainer">
    <v-row class="ma-4 mr-10 pa-0" v-if="!loaded" style="height: 80px; min-height: 80px" align="center" justify="center">
      <v-progress-linear :indeterminate="true" class="ma-2 pa-0"></v-progress-linear>
      <div dense style="text-align: center; width: 100%" class="ma-0 pa-0 subtitle-2" :value="true" color="default">{{ TR.DataProcessingPleaseWait }}</div>
      <div dense style="text-align: center; width: 100%" class="subtitle-2" :value="true" color="default">{{ TR.LocationsFound + ": " + counter + " от " + dataitems.length }}</div>
    </v-row>
    <v-row class="ma-0 pa-0" :class="isOnMobile ? 'box-container' : 'box-container-horizontal'" :style="isOnMobile ? 'flex-direction: column-reverse;' : ''">
      <div class="row-header ma-0 pa-0" ref="refDeviceList">
        <device-list class="ma-0 pa-0 px-1" :devices="getDataItems" v-model="lastDevice" :width="isOnMobile ? '100%' : 220" :height="isOnMobile ? 300 : '100%'" @filterChanged="filterChanged" @click="(item) => showPopUp(item)"> </device-list>
      </div>
      <div class="ma-0 pa-0 row-content">
        <div style="height: 100%; width: 100%; position: relative">
          <v-card style="z-index: 99999; position: absolute; top: 10px; bottom: auto; right: auto; left: 60px; width: 160px" :style="isWithSmallWidth ? 'width: 120px; left: 190px' : ''" class="ma-0 pa-0">
            <v-select class="ma-0 pa-0" hide-details v-if="loaded && hasFuvas" outlined v-model="devsFilterType" :items="devsFilterTypes" item-text="name" dense @change="refreshData" label="Устройства"></v-select>
          </v-card>
          <v-card class="ma-0 pa-0" outlined :style="'z-index: 9999; position: absolute; bottom: 10px; left: 20px; top: auto; right: auto;'">
            <t-button class="ma-0 pa-0" outlined :small="true" :btnIcon="editLocation ? 'mdi-checkbox-marked-circle-outline' : 'mdi-pencil'" :btnText="editLocation ? TR.SaveChanges : TR.EditLocations" @click.native="changeEditMode(true)"></t-button>
          </v-card>
          <v-card class="ma-0 pa-0" :style="'z-index: 9999; position: absolute; bottom: 10px; left: 250px; top: auto; right: auto;'" outlined>
            <t-button v-if="editLocation" :small="true" :btnIcon="'mdi-minus-circle'" :btnText="'Отказ'" @click.native="changeEditMode(false)"></t-button>
          </v-card>
          <!-- <v-text-field v-if="loaded" light class="ma-0 pa-0 py-1" style="z-index: 99999;  position: absolute; top: 10px; bottom: auto; right: auto; left: 230px; width: 160px;" :style="isWithSmallWidth ? 'width: 120px;' : ''" background-color="#fff" label="Търсене на ФУ" outlined v-model="devsSearch" dense @input="refreshData" @keyup.enter="showPopUp(getItems[0])"></v-text-field> -->
          <!-- <t-button :light="true" :small="true" :btnIcon="'mdi-pencil'" :style="'z-index: 9999; background-color: #fff; position: absolute; bottom: 10px; left: 300px; top: auto; right: auto;'" :btnText="'Маршрут'" @click.native="addRoute()"></t-button> -->
          <!-- <v-lazy class="ma-0 pa-0" style="overflow: hidden" :width="mapWidth" :height="mapHeight"> -->
          <!-- <l-map ref="refDeviceMap" @update:zoom="redrawMap" @leaflet:load="mapLoaded" :zoom="currentZoom" :center="currentCenter" :minZoom="currentMinZoom" :maxBounds="currentMaxBounds" :options="mapOptions" @update:center="centerUpdate" :style="(isInDarkMode?'background-color: #fff;':'background-color: #000;')+ 'position: relative; height: ' + mapHeight + '; width: ' + mapWidth">
            <l-tile-layer :url="isInDarkMode?'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png':'http://{s}.tile.osm.org/{z}/{x}/{y}.png'"></l-tile-layer>-->
          <l-map
            ref="refDeviceMap"
            @update:zoom="redrawMap"
            @leaflet:load="mapLoaded"
            :zoom="currentZoom"
            :center="currentCenter"
            :minZoom="currentMinZoom"
            :maxBounds="currentMaxBounds"
            :options="mapOptions"
            @update:center="centerUpdate"
            :style="'width: ' + mapWidth + 'px; height: ' + mapHeight + 'px;'"
          >
            <!-- <l-tile-layer v-if="isInDarkMode" url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'></l-tile-layer> -->
            <l-tile-layer style="z-index: -2" url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'></l-tile-layer>
            <l-marker ref="refLastDeviceMarker" style="color: rgba(33, 33, 33, 0.5); z-index: -1" v-if="lastDevice && lastDevice.AddressLatLng" class="ma-0 pa-0" :lat-lng="lastDevice.AddressLatLng" :icon="icons[lastDevice.Image]">
              <l-popup style="margin: 0; padding: 0" class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <v-tooltip top :disabled="hideTooltips">
                    <template v-slot:activator="{ on }">
                      <span v-if="lastDevice.Status" class="ma-0 pa-0 subtitle-2" v-on="on" style="cursor: pointer">
                        {{ TR.Status + ":" }}
                        <span class="ma-0 pa-0 subtitle-2" :style="`color: ${lastDevice.Status.Color}`">{{ lastDevice.Status.Text }}</span>
                        <v-icon class="ma-0 pa-0 ml-1" small :color="lastDevice.Status.Color">{{ lastDevice.Status.Icon }}</v-icon>
                      </span>
                    </template>
                    <v-row class="ma-0 pa-0" align="center">
                      <span v-if="lastDevice.Status" class="ma-0 pa-0">
                        {{ TR.Status + ":" }}
                        <span class="ma-0 pa-0 subtitle-1">{{ lastDevice.Status.Description }}</span>
                      </span>
                    </v-row>
                    <template v-if="lastDevice.lastTalkDate">
                      <v-row class="ma-0 pa-0 mt-2">
                        <span>{{ TR.LastActivity + ": " }}</span>
                      </v-row>
                      <v-row class="ma-0 pa-0">
                        <span>{{ lastDevice.lastTalkDate.toTremolFpString() }}</span>
                      </v-row>
                    </template>
                  </v-tooltip>
                </v-row>
                <v-divider></v-divider>
                <v-row class="ma-0 pa-0">
                  <span>{{ TR.Name + ": " + lastDevice.Name }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span>{{ TR.SN + ": " + lastDevice.sn }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span>{{ TR.Model + ": " + lastDevice.model.name }}</span>
                </v-row>
                <v-row class="ma-0 pa-0" v-if="lastDevice.client">
                  <span>{{ TR.Firm + ": " + lastDevice.client.orgName }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span>{{ TR.Address + ": " + lastDevice.Address }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <a @click="openTremolSite(lastDevice.model.name.replaceAll(' ', '-'))" target="_blank">{{ TR.Map_DevInstruction }}</a>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <a @click="showModalMap(lastDevice.Address)">{{ TR.Map_ShowInGoogleMaps }}</a>
                </v-row>
                <v-row class="ma-0 pa-0" v-if="editLocation">
                  <a @click="editLastAddress()" target="_blank">{{ TR.Map_DevEditAddress }}</a>
                </v-row>
              </l-popup>
            </l-marker>
            <l-marker
              ref="refCurrentDeviceMarker"
              v-if="currentDevice"
              :draggable="editLocation"
              @dragstart="lastDevDragStart"
              @dragend="lastDevDragEnd"
              @drag="lastDevDrag"
              class="ma-0 pa-0"
              :lat-lng="currentDevice.AddressLatLng"
              :icon="movingLatLng ? icons[currentDevice.Image] : transparentIcon"
              @click="showPopUp(currentDevice)"
            >
              <l-tooltip class="ma-0 pa-0" :options="{ interactive: true, direction: 'top', offset: { x: 0, y: -20 } }">
                <v-row class="ma-0 pa-1">
                  <v-row class="ma-0 pa-0">
                    <span class="ma-0 pa-0 subtitle-2" v-if="currentDevice.Status">
                      {{ TR.Status + ":" }}
                      <span class="subtitle-2" :style="`color: ${currentDevice.Status.Color}`">{{ currentDevice.Status.Text }}</span>
                      <v-icon class="ml-1" small :color="currentDevice.Status.Color">{{ currentDevice.Status.Icon }}</v-icon>
                    </span>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <span>{{ TR.Name + ": " + currentDevice.Name }}</span>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <span>{{ TR.SN + ": " + currentDevice.sn }}</span>
                  </v-row>
                </v-row>
              </l-tooltip>
            </l-marker>
          </l-map>
        </div>
        <!-- </v-lazy> -->
      </div>
    </v-row>
  </div>
</template>
<script>
import L, { latLng, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LTooltip, LPopup, LMarker } from "vue2-leaflet";

import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { g_Dialog, TR } from "../../main";
import "leaflet/dist/leaflet.css";
require("../../../node_modules/leaflet/dist/leaflet.css");
require("../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.js");
require("../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css");
require("../../../src/js/leaflet.canvas-markers.js");
// import StackedCards from "../components/StackedCards";

import { EsriProvider } from "leaflet-geosearch";
import Translation from "../../js/Translation";
const provider = new EsriProvider();

// import { OpenStreetMapProvider } from 'leaflet-geosearch';
// const provider = new OpenStreetMapProvider();

// FIX leaflet's default icon path problems with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

//const imageRed = require("../../assets/img/main/red_background.png");
const imageTransparent = require("../../assets/img/main/transparent_icon.png");

export default {
  name: "leaflet-map",
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    LPopup,
    LMarker,
    // LLayerGroup
    // StackedCards,
  },
  data() {
    return {
      onfocus: false,
      // zoom: 7.2,
      // center: latLng(42.7902107,25.4090009),
      markers: {},
      counter: 0,
      loaded: true,
      currentDevice: null,
      lastDevice: null,
      editLocation: false,
      movingLatLng: null,
      currentZoom: 7.2,
      currentMinZoom: 6.5,
      currentCenter: latLng(42.7902107, 25.4090009),
      currentMaxBounds: latLngBounds([44.405133, 22.093418], [41.361333, 28.602028]),
      mapOptions: {
        zoomSnap: 0.2,
        preferCanvas: true,
        drawControl: true,
      },
      dataitems: [],
      filteredItems: undefined,
      icons: {},
      datatype: null,
      title: "",
      message: null,

      buttonsHeight: 33,
      mapHeight: "100%",
      mapWidth: "100%",
      timeoutRecalcSize: null,
      devsFilterTypes: [
        { id: 0, name: TR.AllDevs },
        { id: 1, name: TR.BlockedDevs },
      ],
      devsFilterType: TR.AllDevs,
      devsSortTypes: [
        { id: 0, name: TR.Device_Name, prop: "Name" },
        { id: 1, name: TR.SN, prop: "sn" },
        { id: 2, name: TR.Address, prop: "Address" },
      ],
      devsSortType: TR.Device_Name,
      devsSearch: null,

      ciLayer: null,
      transparentIcon: L.icon({
        iconUrl: imageTransparent,
        iconSize: [40, 40],
        shadowSize: [0, 0],
        iconAnchor: [20, 20],
        shadowAnchor: [0, 0],
        popupAnchor: [0, 0],
      }),
      TR: TR,
    };
  },
  methods: {
    addRoute() {
      L.Routing.control({
        waypoints: this.dataitems.map((i) => i.AddressLatLng),
        router: new L.Routing.osrmv1({
          language: "ru",
          profile: "car",
        }),
        //geocoder: L.Control.Geocoder.nominatim({}),
      }).addTo(this.$refs.refDeviceMap.mapObject);
    },
    mapLoaded() {
      this.recalcWidthHeight().then(() => {
        this.ciLayer = L.canvasIconLayer({}).addTo(this.$refs.refDeviceMap.mapObject);
        this.ciLayer.addOnHoverListener((event, data) => {
          var markerLatLng = data[0].data._latlng;
          var dev = this.dataitems.find((f) => f.AddressLatLng && f.AddressLatLng.lat == markerLatLng.lat && markerLatLng.lng == markerLatLng.lng);
          if (dev) {
            this.currentDevice = dev;
          }
        });
        this.redrawMap();
      });

      // this.ciLayer.addOnClickListener((event, data) => {
      //   console.log("click listener")
      //   var markerLatLng = data[0].data._latlng;
      //   var dev = this.dataitems.find(f => f.AddressLatLng.lat == markerLatLng.lat && markerLatLng.lng == markerLatLng.lng);
      //   if (dev) {
      //     this.showPopUp(dev);
      //   }
      // });
    },
    changeEditMode(save) {
      if (this.editLocation) {
        if (save) {
          if (TR.Locale == Translation.bg.Locale) {
            DataManager.updateDevProfile([...this.dataitems]);
          } else {
            //TODO
          }
        } else {
          DataManager.reloadDeviceData();
        }
        this.editLocation = false;
        this.movingLatLng = null;
      } else {
        this.editLocation = true;
        this.currentDevice = this.lastDevice;
        this.lastDevice = null;
        this.dialogLoader.showInfo(TR.Map_ClickAndEdit);
      }
    },
    editLastAddress() {
      if (!this.lastDevice) return;
      g_Dialog.show(
        g_Dialog.dialog_types.input_dialog,
        this.lastDevice.Address,
        {
          title: "Редакция на адрес:",
          placeholder: "Адрес",
          buttonYesText: "OK",
          buttonCancelText: "Отказ",
        },
        async (newAddress) => {
          if (newAddress) {
            this.lastDevice.Address = newAddress.replace('"', "");
            await provider.search({ query: newAddress }).then((result) => {
              if (result.length > 0) {
                this.lastDevice.AddressLatLng = latLng(result[0].y, result[0].x);
                if (TR.Locale != Translation.bg.Locale) {
                  DataManager.updateDevNameAndSettingsGlobal(this.lastDevice.sn, null, this.lastDevice.settings1);
                }
              }
            });
          }
        }
      );
    },
    lastDevDrag(e) {
      this.movingLatLng = e.target.getLatLng();
      if (this.currentDevice) {
        this.currentDevice.AddressLatLng = e.target.getLatLng();
        this.markers[this.currentDevice.id].setLatLng([this.currentDevice.AddressLatLng.lat, this.currentDevice.AddressLatLng.lng]);
        this.ciLayer.redraw();
      }
      this.$forceUpdate();
    },
    lastDevDragStart() {
      // this.ciLayer.setOpacity(0);
    },
    lastDevDragEnd() {
      if (this.currentDevice) {
        //this.lastDevice = this.currentDevice;
        this.currentDevice = null;
      }
      this.$nextTick(() => {
        // this.ciLayer.setOpacity(1);
        this.$forceUpdate();
      });
    },
    setFocus(on) {
      this.onfocus = on;
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} error
     */
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.title = meta.title;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.refreshData();
      } else {
        this.message = error.Message;
      }
    },
    refreshData() {
      if (this.loaded) {
        this.loaded = false;
        this.currentDevice = null;
        this.lastDevice = null;
        this.counter = 0;
        var changed = 0;
        this.dataitems = [];
        this.$nextTick(async () => {
          this.dataitems = DataManager.getData(this.datatype, true);

          //var filterIdx = this.devsFilterTypes.findIndex(f => f.name == this.devsFilterType);
          try {
            Object.values(this.markers).forEach((mm) => this.ciLayer.removeMarker(mm, true));
          } catch (err) {
            /** ignored */
          }
          this.markers = [];
          var itemsWoAddress = this.getItems.filter((i) => !i.AddressLatLng || !i.AddressLast || i.AddressLast != i.Address);
          this.counter = this.getItems.length - itemsWoAddress.length;
          await itemsWoAddress
            .asyncForEach(async (i) => {
              if (i.Address) {
                await provider.search({ query: i.Address }).then((result) => {
                  if (result.length > 0) {
                    var item = this.dataitems.find((f) => f.id == i.id);
                    item.AddressLatLng = latLng(result[0].y, result[0].x);
                    item.AddressLast = i.Address.replace('"', "");
                    changed++;
                    if (TR.Locale != Translation.bg.Locale) {
                      console.log(item);
                      DataManager.updateDevNameAndSettingsGlobal(item.sn, null, item.settings1);
                    }
                  }
                });
              }
              this.counter++;
              return this.counter;
            })
            .then(() => {
              this.getItems.forEach((i) => {
                if (!this.icons[i.Image]) {
                  this.icons[i.Image] = L.icon({
                    iconUrl: i.Image,
                    //shadowUrl: i.IsBlocked ? imageRed : i.Image,
                    iconSize: [40, 40],
                    shadowSize: [0, 0],
                    iconAnchor: [20, 20],
                    shadowAnchor: [0, 0],
                    popupAnchor: [0, 0],
                  });
                }
                //if ((filterIdx == 0 || (i.IsFuvas && i.IsBlocked)) && (!this.devsSearch || i.Name.contains(this.devsSearch) || i.sn.contains(this.devsSearch))) {
                if (i.AddressLatLng) {
                  this.markers[i.id] = L.marker(i.AddressLatLng, {
                    customid: i.id,
                    icon: this.icons[i.Image],
                  });
                }
                //}
              });
              this.loaded = true;
              if (this.markers.length > 0) {
                this.ciLayer.addMarkers(Object.values(this.markers));
                if (changed > 0 && TR.Locale == Translation.bg.Locale) {
                  DataManager.updateDevProfile([...this.dataitems]);
                }
              }
              this.redrawMap();
            });
        });
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showPopUp(item) {
      if (!this.editLocation) {
        this.currentDevice = null;
        this.lastDevice = item;
      } else {
        this.lastDevice = null;
      }

      //this.markers.forEach(m => m.setOpacity(0));
      this.$nextTick(() => {
        if (item && item.AddressLatLng) {
          this.$refs.refDeviceMap.mapObject.once("moveend", () => {
            this.$nextTick(() => {
              this.ciLayer.setOpacity(1);
              if (this.$refs.refLastDeviceMarker) {
                this.$refs.refLastDeviceMarker.mapObject.openPopup();
              }
            });
          });
          this.ciLayer.setOpacity(0);
          this.$refs.refDeviceMap.mapObject.flyTo(item.AddressLatLng, 15);
          // this.dataitems.forEach(i => {
          //   this.$refs["marker" + i.sn + "ref"][0].mapObject.setZIndexOffset(0);
          // });
          // this.$refs["marker" + item.sn + "ref"][0].mapObject.setZIndexOffset(this.dataitems.length - 1);
        }
      });
    },
    showModalMap(devaddress) {
      this.dialog.show("google-map", null, {
        //this.$modal.show("modal-map", {
        address: devaddress,
      });
    },
    async recalcWidthHeight() {
      new Promise((resolve) => {
        if (this.timeoutRecalcSize) clearTimeout(this.timeoutRecalcSize);
        this.timeoutRecalcSize = setTimeout(() => {
          if (this.$refs && this.$refs.refDeviceList && this.$refs.refContainer) {
            if (this.isOnMobile) {
              this.mapHeight = this.$refs.refContainer.clientHeight - this.$refs.refDeviceList.clientHeight;
              this.mapWidth = this.$refs.refContainer.clientWidth;
            } else {
              this.mapHeight = this.$refs.refContainer.clientHeight;
              this.mapWidth = this.$refs.refContainer.clientWidth - this.$refs.refDeviceList.clientWidth;
            }
            this.$nextTick(() => {
              this.redrawMap();
              resolve();
            });
          }
        }, 20);
      });
    },
    redrawMap() {
      if (this.$refs.refDeviceMap) {
        this.$refs.refDeviceMap.mapObject.invalidateSize();
      }
    },
    filterChanged(filtered) {
      this.filteredItems = filtered;
    },
  },
  computed: {
    hasFuvas() {
      return this.dataitems && this.dataitems.some((d) => d.IsFuvas);
    },
    getDataItems() {
      var filterIdx = this.devsFilterTypes.findIndex((f) => f.name == this.devsFilterType);
      return this.dataitems.filter((i) => filterIdx == 0 || (i.IsFuvas && i.IsBlocked));
    },
    getItems() {
      var filterIdx = this.devsFilterTypes.findIndex((f) => f.name == this.devsFilterType);
      return (this.filteredItems == undefined ? this.dataitems : this.filteredItems).filter((i) => filterIdx == 0 || (i.IsFuvas && i.IsBlocked));
      // var prop = this.devsSortTypes.find(st => st.name == this.devsSortType).prop;
      // return this.dataitems.filter(i => (filterIdx == 0 || (i.IsFuvas && i.IsBlocked)) && (!this.devsSearch || i.Name.contains(this.devsSearch) || i.sn.contains(this.devsSearch))).sort((a, b) => a[prop].localeCompare(b[prop], "bg", { sensitivity: "base" }));
    },
  },
  watch: {
    isBannerVisible() {
      this.recalcWidthHeight();
    },
  },
  mounted() {
    if (TR.Locale == Translation.ro.Locale) {
      this.currentCenter = latLng(45.7326495, 24.9396868);
      this.currentMaxBounds = latLngBounds([48.515133, 20.093418], [43.531333, 30.002028]);
    } else if (TR.Locale == Translation.md.Locale) {
      this.currentCenter = latLng(47.2350987, 28.6226419);
      this.currentMaxBounds = latLngBounds([49.405133, 26.093418], [44.361333, 31.602028]);
    }
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == this.datatype && this.onfocus) {
        this.refreshData();
      }
    });
    this.recalcWidthHeight();
  },
};
</script>

<style>
.theme--dark.v-application .leaflet-tile {
  filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg) saturate(0.3) brightness(0.6) !important;
}

.theme--dark.v-application .leaflet-popup-content-wrapper {
  border: 1px solid white;
}

.theme--dark.v-application .leaflet-popup-content-wrapper,
.theme--dark.v-application .leaflet-tooltip {
  background-color: #222;
  color: white;
}
</style>